module.exports = __webpack_public_path__ + "static/media/fedpapers-bg.15c9887c.jpg";